module.exports = __webpack_public_path__ + "static/img/yogur.9940d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/yogur.png
// module id = 251
// module chunks = 1